import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=d6ef76c2&scoped=true&lang=html"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=d6ef76c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ef76c2",
  null
  
)

export default component.exports